var _rect, _path, _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.46875,
    y: 12.375,
    width: 13.4187,
    height: 26.4428,
    rx: 6.70937,
    transform: "rotate(-45 -2.46875 12.375)",
    fill: "url(#paint0_linear_20761_137775)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9834 26.3271L30.1928 17.1177C32.813 14.4975 32.813 10.2494 30.1928 7.62919C27.5727 5.00903 23.3246 5.00902 20.7044 7.62915L20.7044 7.62919L11.6804 16.6531C10.648 17.6856 9.13531 18.4239 7.33218 18.725C5.52904 19.0261 3.53418 18.3792 3.53418 18.3792L11.4949 26.3271C14.1151 28.9473 18.3632 28.9473 20.9834 26.3271Z",
    fill: "url(#paint1_linear_20761_137775)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9902,
    cy: 14.1486,
    r: 1.2658,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8256,
    cy: 17.3576,
    r: 1.2658,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3901,
    cy: 20.2951,
    r: 1.2658,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20761_137775",
    x1: 4.24062,
    y1: 12.375,
    x2: 1.79961,
    y2: 26.2727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6183FF",
    stopOpacity: 0.958333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20761_137775",
    x1: 11.3314,
    y1: 16.9783,
    x2: 49.3846,
    y2: -1.02453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86A0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4eba1006b1aafe65a516ee25fb1477f4.svg";
export { ForwardRef as ReactComponent };